import axios from "axios";
import config from "./config";

export const verifyTokens = (body) => {
  return axios.post("/auth/create_with_token", body, config);
}
